Alerts = require 'views/lib/alerts'
l = require 'lib/localize'
rpc = require 'network/rpc'
templates = require 'views/internal/templates'

module.exports = ->
  showConnectingTimeout = null

  showConnectFailed = =>
    clearTimeout(showConnectingTimeout)
    Alerts.hide('connection')
    #Different area for connection dead to make it immune to race conditions
    msg = l('alerts.could not connect')
    Alerts.showHtml(templates.fill('connect_failed', { msg }), 'error', 'connectionDead')

  rpc.on 'connect_failed', showConnectFailed
  rpc.on 'reconnect_failed', showConnectFailed

  fxReconn = =>
    clearTimeout(showConnectingTimeout)
    Alerts.hide('connection')
    Alerts.hide('connectionDead')

  fxConn = =>
    # Only show the "Connecting" alert if we've been disconnected for more
    # than 500ms. This should cut down on it flashing really briefly when you
    # have a flaky internet connection.
    clearTimeout(showConnectingTimeout)
    showConnectingTimeout = setTimeout =>
      showConnectingTimeout = null
      Alerts.show('reconnecting', 'error', 'connection')
    , 500

  rpc.on 'reconnect', fxReconn
  rpc.on 'connecting', fxConn



// WEBPACK FOOTER //
// ./app/scripts/network/alert-sync-errors.coffee